import clsx from "clsx";
import { DivIcon } from "leaflet";
import "leaflet/dist/leaflet.css";
import { renderToStaticMarkup } from "react-dom/server";
import { Icon } from "./icon";
import { DetourTypeName, IDetour, IPOI } from "./map";

interface IDetourMarkersIcon {
  tag: string;
  src: string;
  color: string;
  backgroundColor: string;
}

export const fallBackIcon: IDetourMarkersIcon = {
  tag: "Werkzaamheden",
  src: "ri-calendar-schedule-line",
  color: "#000",
  backgroundColor: "#FB8500",
};

export const detourMarkersIcons = new Map<DetourTypeName, IDetourMarkersIcon>([
  [
    "Werkzaamheden",
    {
      tag: "Werkzaamheden",
      src: "ri-barricade-line",
      color: "#000",
      backgroundColor: "#FB8500",
    },
  ],
  [
    "Spoor",
    {
      tag: "Spoor",
      src: "ri-train-line",
      color: "#FFF",
      backgroundColor: "#0063D3",
    },
  ],
  [
    "Evenementen",
    {
      tag: "Evenementen",
      src: "ri-coupon-2-fill",
      color: "#1D4437",
      backgroundColor: "#B9E73A",
    },
  ],
]);

export const defaultMakersConfig = {
  iconWidth: 32,
  iconHeight: 32,
  color: "#000",
  fillColor: "#FFA20C",
  backgroundColor: "#FFA20C",
};

export function MarkerIcon({
  item,
  detourMarker,
}: {
  item: IDetour | IPOI;
  detourMarker?: IDetourMarkersIcon;
}) {
  return new DivIcon({
    html: renderToStaticMarkup(
      <div
        className="flex rounded-full justify-center items-center h-9 w-9"
        style={{
          backgroundColor:
            ("detourType" in item
              ? detourMarker?.backgroundColor
              : item.type.styling.backgroundColor) ?? defaultMakersConfig.backgroundColor,
        }}
      >
        {"detourType" in item ? (
          <i
            className={clsx("text-xl", detourMarker?.src)}
            style={{ color: detourMarker?.color }}
          ></i>
        ) : (
          <Icon
            icon={item.type.styling?.icon}
            className="p-1"
            style={{
              width: defaultMakersConfig.iconWidth,
              height: defaultMakersConfig.iconHeight,
            }}
            color={item.type.styling?.color ?? defaultMakersConfig.color}
            strokeWidth={2}
            absoluteStrokeWidth={true}
          />
        )}
      </div>
    ),
    className: "disable-default-marker-styling",
    iconSize: [defaultMakersConfig.iconWidth, defaultMakersConfig.iconHeight],
  });
}
